import { useState } from 'react'
import ResponseMessage from '../../common/modal/ResponseMessage'
import { performRequest } from '../../common/utils'
import MicroModal from 'micromodal'
import { HandleShowCloseModal } from '../../common/modal/HandleShowCloseModal'

const AddSeats = ({team}) => {  
    const [ seat, setSeat ] = useState(1)
    const totalSeatCount = Number(seat) + Number(team.team_seat_count)
    const seatChangeMessage = `This action will add ${seat} seats, resulting in a total of ${ totalSeatCount } seats`
    const [ responseMessage, setResponseMessage ] = useState()
    const seatBtn = team.is_admin ? "Grant Seats" : "Buy Seats"
    const [ cartUrl, setCartUrl ] = useState()
    const [ isRequesting, setIsRequesting ] = useState( false )
    
    MicroModal.init()

    const handleGrantSeat = async() => {
        const formData = new FormData()
        formData.append('action', 'tms_csv_import_add_seat')
        formData.append('team_id', team.team_id)
        formData.append('seat_count', seat)
        formData.append('nonce', msyncCsvImport.nonce_create)

        try {
            setIsRequesting(true)
            const request = await performRequest(msyncCsvImport.url, formData)
            
            if( request.url !== msyncCsvImport.url){
                setCartUrl(request.url)
                setResponseMessage({
                    type: 'success',
                    message: 'Successfully added to cart'
                })
                return
            }

            const res = await request.json()

            if( !res.success ){
                throw new Error(res.errors.shift())
            }

            setResponseMessage({
                type:'success',
                message: 'Successfully added seats'
            })

        } catch (error) {
            setResponseMessage({
                type: 'error',
                message: `Error: ${error}`
            })
        } finally {
            setIsRequesting( false )
        }
    }

    const handleCloseSeats = () => {
        HandleShowCloseModal('msync-upload-csv-modal','msync-modal-add-seats')
    }

    return (
        <>
            <main className="modal__content msync-add-seat-csv">
                { responseMessage && <ResponseMessage response={ responseMessage } /> }
                <div className="msync-modal-upload-container msync-col">
                    <p>Enter the number of seats you would like to add to this team</p>
                    <input type="number" value={seat} min="1" onChange={(e) => setSeat(e.target.value)}/>
                    <p>{ seatChangeMessage }</p>
                </div>
            </main>
            <footer className="modal__footer">
                {
                    ( responseMessage?.type === 'success' && team.is_admin ) ? 
                    ( <a href={msyncCsvImport.current_url} className='msync-button msync-button-md msync-filled-primary-anchor'>Reload Page</a> ) :
                    ( responseMessage?.type === 'success' && !team.is_admin ) ?
                    ( <a href={cartUrl} className='msync-button msync-button-md msync-filled-primary-anchor' >Go to Cart</a> ) :
                    ( <button type="button" value="submit" className='msync-button msync-button-md msync-filled-primary-button' onClick={handleGrantSeat} disabled={isRequesting}>{ isRequesting ? 'Loading...' : seatBtn }</button> )
                }
            </footer>
        </>
    )
}

export default AddSeats